import { ReactElement } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { ResponseData } from "shared/cbt/api/fetchPassengerNotification";

import { LegacyModalAlert } from "../UI/useModalAlert";

type Props = {
  show: boolean;
  onClose: () => void;
  notifications: ResponseData[];
};

export const PassengerNotificationsModal = ({
  show,
  onClose,
  notifications,
}: Props): ReactElement => {
  const { formatMessage } = useIntl();

  const notificationsGroupedBySameText = notifications.reduce(
    (accumulator, current) => {
      if (Object.keys(accumulator).includes(current.Message)) {
        accumulator[current.Message].push(current);
      } else {
        accumulator[current.Message] = [current];
      }

      return accumulator;
    },
    {}
  );

  const notificationRows = Object.keys(notificationsGroupedBySameText).map(
    (key, index) => {
      return (
        <div key={index} className="passenger-notification-row">
          <div className="passenger-notification-row__passengers-wrapper">
            <span className="passenger-notification-row__passengers-title">
              <FormattedMessage id="Results.passengersNotificationsPassengers" />
            </span>
            {notificationsGroupedBySameText[key]
              .map(
                (notification) =>
                  `${notification.FirstName} ${notification.LastName}`
              )
              .join(", ")}
          </div>
          <div className="passenger-notification-row__message">{key}</div>
        </div>
      );
    }
  );

  return (
    <LegacyModalAlert
      show={show}
      onClose={onClose}
      customClassName="modal-alert--passenger-notifications"
      customContent={notificationRows}
      customButtons={{
        label: formatMessage({ id: "passenger.notification.agree" }),
        className:
          "button button-secondary-color passenger-notification-button",
        onClick: onClose,
      }}
      disableOutsideClose
      hideHeader
      customBodyStyles={{
        maxWidth: "600px",
      }}
    />
  );
};

export default PassengerNotificationsModal;
